
export { BLITZ_FONTS } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-ui/consts/theme/fonts/blitzFonts.ts"
export { VERTEX_FONTS } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-ui/consts/theme/fonts/vertexFonts.ts"